import type { ActionReducerMap } from '@ngrx/store';

import type { AuthState } from './auth/store';
import type { CoreState, Pagination } from './core/store';
import type { State as FilteredTableState } from './shared/modules/filtered-table/store/filtered-table.reducer';
import type { State as ExternalSharingState } from './shared/modules/external-sharing/store/external-sharing.reducer';
import type { State as ReadOnlyState } from './shared/modules/read-only/store/read-only.reducer';
import type { ProjectsState } from './project/store';
import type { UserState } from './user/store';

export interface AppState {
  user: UserState;
  auth: AuthState;
  core: CoreState;
  pagination: Pagination;
  externalSharing: ExternalSharingState;
  projects: ProjectsState;
  readOnly: ReadOnlyState;
  filteredTable: FilteredTableState;
}

// Every slice is provided at its own route or in `main.ts` via `provideState`, so the root map is empty.
// `ActionReducerMap` is homomorphic, so `Partial` is what makes that sayable.
export const reducers: ActionReducerMap<Partial<AppState>> = {};
